import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const OldSlugRedirect = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/');
  }, []);

  return <></>;
};

export default OldSlugRedirect;
